<template>
  <v-dialog :value="show" @input="$emit('close')" max-width="800px" scrollable>
    <v-card :class="classes" :style="styles + ';' + gradient">
      <view-text :settings="component.dialog.title" :value="title"></view-text>
      <v-card-text v-html="content" class="help-dialog-content"></v-card-text>

      <v-card-actions>
        <v-btn @click="onClose" elevation="0" text>
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ViewText from "@/components/Design/View/ViewComponents/Shared/Text.vue";

export default {
  components: {
    ViewText
  },
  props: {
    title: {
      type: String,
      default: "Help Title Goes Here"
    },
    content: {
      type: String,
      default: "Help content goes here"
    },
    show: {
      type: Boolean,
      default: false
    },
    component: {
      type: Object,
      required: true
    }
  },
  methods: {
    onClose() {
      this.$emit("close");
    }
  },
  computed: {
    buttonColor() {
      if (
        this.component.dialog.button &&
        this.component.dialog.button.color &&
        this.component.dialog.button.color.hexa
      ) {
        return this.component.dialog.button.color.hexa;
      } else {
        return this.$store.state.program.currentProgram.webTheme.colors.primary
          .hexa;
      }
    },
    buttonTextColor() {
      if (this.component.dialog.button && this.component.dialog.button.dark) {
        return this.component.dialog.button.dark;
      } else {
        return "white--text";
      }
    },
    classes() {
      if (this.component.dialog.fullscreen === true) return "rounded-0";
      return this.component.card.rounded;
    },
    gradient() {
      if (this.component.dialog.color.type === "gradient") {
        var color = this.component.dialog.color;
        var gradient =
          "background: linear-gradient(" +
          color.direction +
          ", rgba(" +
          color.gradientFrom.rgba.r +
          ", " +
          color.gradientFrom.rgba.g +
          ", " +
          color.gradientFrom.rgba.b +
          ", " +
          color.gradientFrom.rgba.a +
          ") " +
          ", rgba(" +
          color.gradientTo.rgba.r +
          ", " +
          color.gradientTo.rgba.g +
          ", " +
          color.gradientTo.rgba.b +
          ", " +
          color.gradientTo.rgba.a +
          ")" +
          color.gradientHeight +
          "%)";
        return gradient;
        // return 'background: linear-gradient(to top, rgba(0, 0, 255, 100), rgba(255, 0, 0, 100) 50%)'
      } else {
        return (
          "background: " + this.component.dialog.color.solidColor.hexa + ";"
        );
      }
    },
    styles() {
      // Helper function to ensure minimum padding
      const ensureMinPaddingX = value => Math.max(28, value);
      const ensureMinPaddingY = value => Math.max(20, value);

      var styles =
        "padding-bottom: " +
        ensureMinPaddingY(this.component.dialog.padding.bottom) +
        "px ;" +
        "padding-top: " +
        ensureMinPaddingY(this.component.dialog.padding.top) +
        "px ;" +
        "padding-left: " +
        ensureMinPaddingX(this.component.dialog.padding.left) +
        "px ;" +
        "padding-right: " +
        ensureMinPaddingX(this.component.dialog.padding.right) +
        "px ;" +
        "border: " +
        this.component.dialog.borderSize +
        "px solid " +
        ";";
      this.component.dialog.borderColor.hexa + "; ";
      return styles;
    }
  }
};
</script>

<style scoped>
::v-deep .help-dialog-content {
  line-height: 1.4;
}

::v-deep .help-dialog-content h3 {
  margin-top: 24px;
  margin-bottom: 16px;
  font-weight: 600;
  color: #303030;
}

::v-deep .help-dialog-content h3:first-child {
  margin-top: 0;
}

::v-deep .help-dialog-content h4 {
  margin-top: 20px;
  margin-bottom: 12px;
  font-weight: 600;
  color: #303030;
}

::v-deep .help-dialog-content p {
  margin-bottom: 12px;
  color: #555;
}

::v-deep .help-dialog-content ul,
::v-deep .help-dialog-content ol {
  margin-bottom: 16px;
  padding-left: 24px;
}

::v-deep .help-dialog-content li {
  margin-bottom: 6px;
  line-height: 1.5;
}

::v-deep .help-dialog-content ul li {
  list-style-type: disc;
}

::v-deep .help-dialog-content ol li {
  list-style-type: decimal;
}

::v-deep .help-dialog-content li ul {
  margin-top: 6px;
  margin-bottom: 6px;
  padding-left: 20px;
}

::v-deep .help-dialog-content pre {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  padding: 12px;
  margin: 16px 0;
  font-family: "Courier New", monospace;
  font-size: 13px;
  overflow-x: auto;
}

::v-deep .help-dialog-content code {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 3px;
  padding: 2px 4px;
  font-family: "Courier New", monospace;
  font-size: 13px;
}

::v-deep .help-dialog-content pre code {
  background: none;
  border: none;
  padding: 0;
}

::v-deep .help-dialog-content strong {
  font-weight: 600;
  color: #303030;
}
</style>
